export const labelStyle = {
    display: 'block',
    textAlign: 'left',
    fontSize: 12,
    color: '#414141',
    marginBottom: 5
};

export const inputStyle = {
    boxSizing: 'border-box',
    width: '100%',
    height: 40,
    outline: 'none',
    autoComplete: 'off',
    padding: '0 12px',
    fontSize: 15,
    letterSpacing: -0.3,
    fontWeight: 600
};

export const gridItemStyle = {
    textAlign: 'center',
    padding: 0
};

export const gridContainerStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateRows: '50px 57px 1fr',
    gridGap: 0,
    padding: '19px 40px 36px 40px'
};

export const tabAreaStyle = {
    gridColumn: '1 / 4',
    paddingTop: 18
};

export const tableAreaStyle = {
    gridColumn: '1 / 4',
    backgroundColor: '#FFFFFF'
};

export const gridViewCreateButtonStyle = {
    width: 130,
    height: 40,
    fontSize: 14
};

export const tabPanelStyle = {
    boxShadow: 'unset',
    border: 'unset',
    borderRadius: 'unset'
};

export const detailsTitleStyle = {
    fontSize: 22,
    fontWeight: 500,
    color: '#414141',
    padding: '0px 0px 21px 47px'
};

export const disabledSelectStyle = {
    fontSize: 15,
    opacity: 1
};

export const disabledButtonStyle = {
    border: '1px solid #A6A6A6',
    borderRadius: 5,
    backgroundColor: '#CCCCCC',
    cursor: 'auto'
};

export const sectionedPanelStyle = {
    boxSizing: 'border-box',
    border: '1px solid #D7D7D7',
    borderRadius: 8,
    backgroundColor: '#FFFFFF'
};
